import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login';
import Helpers from '@/util/Helpers';
import { SET_PERMISSAO } from '@/store/mutations';

Vue.use(Router);

var router = new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            props: true,
            component: Login,
            meta: { icon: '', description: 'Login' }
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/views/Home.vue'),            
            meta: { icon: 'home', description: 'Home', requiresAuth: true, grantAll: true },
            redirect: { name: 'principal' },            
            children: [
                {
                    path: '/principal',
                    name: 'principal',
                    component: () => import('@/views/Principal.vue'),
                    meta: { icon: 'home', description: 'Home', requiresAuth: true, grantAll: true },
                },
                {
                    path: '/usuario',
                    name: 'usuario',
                    component: () => import('@/views/Usuario.vue'),
                    meta: { icon: 'user', description: 'Gerenciamento de Usuários', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/cliente',
                    name: 'cliente',
                    component: () => import('@/views/Cliente.vue'),
                    meta: { icon: 'user', description: 'Gerenciamento de Clientes', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/perfilTribunal',
                    name: 'perfil',
                    component: () => import('@/views/PerfilTribunal.vue'),
                    meta: { icon: 'user', description: 'Gerenciamento de Perfis', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/fontes',
                    name: 'fontes',
                    component: () => import('@/views/Contrato.vue'),
                    meta: { icon: 'folder', description: 'Gerenciamento de Fontes', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/controleFontes',
                    name: 'controleFontes',
                    component: () => import('@/views/ControleContrato.vue'),
                    meta: { icon: 'control', description: 'Controle de Fontes', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/aprovacaoGestor',
                    name: 'aprovacaoGestor',
                    component: () => import('@/views/AprovacaoGestor.vue'),
                    meta: { icon: 'folder', description: 'Aprovação Gestor', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/visualizarIntimacoes',
                    name: 'visualizarIntimacoes',
                    component: () => import('@/views/VisualizarIntimacoes.vue'),
                    meta: { icon: 'tag', description: 'Visualizar Intimações', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/controleIntimacoes',
                    name: 'controleIntimacoes',
                    component: () => import('@/views/ControleIntimacao.vue'),
                    meta: { icon: 'control', description: 'Controle de Intimações', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/fontesPOL',
                    name: 'fontesPOL',
                    component: () => import('@/views/FontesPOL.vue'),
                    meta: { icon: 'setting', description: 'Manutenção Fontes POL', requiresAuth: true, grantAll: false },
                },
            ],
        },
    ],
});
router.beforeEach((to, from, next) => {
    var userPerfilPortal = router.app.$store.state.auth.idPerfilPortal;
    if (to.matched.some(record => record.meta.requiresAuth) && (!router.app.$store.state.auth.token || router.app.$store.state.auth.token === 'null')) {

        next({
            path: '/',
            query: { redirect: to.fullPath }
        });
    } else {        
        if (to.meta.grantAll == false) {
            let listGrants = [];
            listGrants = Helpers.buscarPerfilPortalTela(to.name);
            if (listGrants.includes(userPerfilPortal)) {
                next();
            } else {
                router.app.$store.commit(SET_PERMISSAO, { user_no_permission: { temPermissao: false } });
                next({
                    name: 'home',
                    query: { redirect: to.fullPath }
                });
            }
        } else {
            next();
        }
    }
});

export default router;